"use client";

import Button, { ButtonType } from "@/app/(components)/generics/Button/Button";
import { ModalStore } from "@/app/stores/ModalStore";
import { DefaultProps } from "@/app/types/common/DefaultProps";
import styles from "./BlogCta.module.css";

type Props = DefaultProps & {
  title: string;
  text: string;
  btn: string;
};

export default function BlogCta(props: Props) {
  const { title, text, btn, params } = props;

  return (
    <div className={styles.container}>
      <h2 className={styles.title}>{title}</h2>
      <p className={styles.text}>{text}</p>
      <Button
        min={false}
        params={params}
        text={btn}
        isLink={false}
        type={ButtonType.SOFT}
        onClick={() => ModalStore.getState().openDemo()}
      />
    </div>
  );
}
